import type { Nil, Patient } from '@pbt/pbt-ui-components'

import type { InvoiceOrEstimate } from '~/types'

type PatientIdSource = Pick<InvoiceOrEstimate, 'patientId'>

/**
 * Resolves client and patient ids for {@link SearchChargeTab} when the estimate
 * is shown outside a SOAP context (invoice prop / local invoice state may disagree).
 */
export function resolveSearchChargeTabClientId(args: {
  clientId: string | Nil
  invoice: Pick<InvoiceOrEstimate, 'clientId'>
}): string | undefined {
  const { clientId, invoice } = args
  return clientId ?? invoice.clientId ?? undefined
}

export function resolveSearchChargeTabPatientId(args: {
  invoice: PatientIdSource
  invoiceProp: PatientIdSource
  patient?: Patient
}): string | undefined {
  const { invoice, invoiceProp, patient } = args
  return patient?.id ?? invoice.patientId ?? invoiceProp?.patientId ?? undefined
}
